module.exports = __webpack_public_path__ + "static/media/logo.17981198.png";